import * as React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'
import ReactPlayer from 'react-player'
import PropTypes from 'prop-types'
import Slider from "react-slick";
import SliderArrow from '../../components/layout/SliderArrow'
import FlickerGallery from '../../components/layout/FlickrGallery'
import styled from '../../utils/styled'
import MediaItem from './MediaItem'
import './FullSizePage.scss'

interface FullSizePageProps {
  title: string
  subtitle: string
  backgroundImage: string
  className: string
}
const settings = {
  dots: true,
  infinite: true,
  prevArrow: <SliderArrow to="prev" faIcon="arrow-left" />,
  nextArrow: <SliderArrow to="next" faIcon="arrow-right" />,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};
const FullsizeSection: React.SFC<FullSizePageProps> = ({
  children,
  title,
  subtitle,
  media,
  className = '',
  theme = 'light'
}) => (
  <div
    className={
      (theme === '' ? '' : theme + ' ') +
      (className === '' ? '' : className + ' ') +
      'page content parallax'
    }
  >
    <div className="container-fluid no-padding">
      <div className="jumbotron jumbotron-fluid">
        <div className="container">
          <ScrollAnimation animateIn="slideInUp" animateOnce={true} initiallyVisible={true}>
            <ScrollAnimation
              className="side-description"
              animateIn="headerLineIn"
              animateOnce={true}
            >
              { (title && title!='') &&
              (<ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" animateOnce={true}>
                <h1>{title}</h1>
              </ScrollAnimation>) }
              { (subtitle && subtitle!='') && (<ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" animateOnce={true} delay={1}>
                 <h2>{subtitle}</h2>
              </ScrollAnimation>)}
              <span>{children}</span>
            </ScrollAnimation>
          </ScrollAnimation>

          <ScrollAnimation animateIn="slideInUp" animateOnce={true} >
            { (media!=undefined) && (!media.hasOwnProperty("url")) &&
                    (<Slider className="page-gallery" style={{width: "100%", height: "100%"}} {...settings}>{Object.keys(media).map((key, index) => (<MediaItem key={index} type={media[key].type} caption={media[key].label} url={media[key].url } />)}</Slider>)
                }
              {media!=undefined && media.hasOwnProperty("url") &&
              <MediaItem type={media.type} url={media.url} caption={media.label} />
            }
          </ScrollAnimation>
        </div>
      </div>
    </div>
  </div>
)
// (<Slider {...settings}>
//   {Object.keys(media).map((item, index) => (<MediaItem type={item.type} url={item.url} />)}
// </Slider>)
export default FullsizeSection
